import React, { useContext, useEffect, useState } from 'react';
import { DataLayerEventContext } from '../contexts/dataLayerEventContext';
import styles from '../components/lm-d-s/index.module.scss';
import { ScreensContext } from '../contexts/screensContext';
import SuccessRegistered from '../components/promoter/success-registered';
import WelcomeScreen from '../components/ua-brand/welcome-screen';
import CompanyInfoScreen from '../components/ua-brand/company-info-screen';
import FaqScreen from '../components/ua-brand/faq-screen';
import CookieManagementScreen from '../components/ua-brand/cookie-management-screen';
import WelcomeAgeVerificationScreen from '../components/ua-brand/welcome-age-verification-screen';
import FaceCaptureScreen from '../components/ua-brand/face-capture-screen';
import YoungAgeScreen from '../components/ua-brand/young-age-screen';
import WelcomeFormScreen from '../components/ua-brand/welcome-form-screen';
import FormScreen from '../components/ua-brand/form-screen';
import OtpScreen from '../components/ua-brand/otp-screen';
import AlreadyRegistered from '../components/promoter/already-registered';
import GeoresctrictionScreen from '../components/ua-hostess/georesctriction-screen';
import ErrorPage from '../components/ua-brand/errror-page';
import AttemptsExhausted from '../components/ua-brand/attempts-exhausted';
import NotRealFaceScreen from '../components/ua-brand/not-real-face-screen';
import ErrorPage500 from '../components/ua-brand/error-page-500';
import ErrorPage503 from '../components/ua-brand/error-page-503';
import ErrorPage404 from '../components/ua-brand/error-page-404';
import useScreenHistory from '../hooks/useScreenHistory';

const utm_campaign = sessionStorage.getItem('utm_campaign');

const Promoter = () => {
  const [formData, setFormData] = useState({});
  const { screenNumber, setScreenNumber } = useScreenHistory({
    initialScreen: !utm_campaign ? 14 : 1
  });
  const [endSessionType, setEndSessionType] = useState('SESSION_END');
  const [isDisplayedAll, setIsDisplayedAll] = useState(false);
  const [isVisibleModal, setIsVisibleModal] = useState(true);
  const [isLoadCountry, setIsLoadCountry] = useState(false);
  const telegramLink = `https://t.me/pmu_support_bot?start=ScnPck-${utm_campaign}`;

  const { init, sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [screenNumber]);

  useEffect(() => {
    init(`${sessionStorage.getItem('isQrCode')}`);
  }, [init]);

  useEffect(() => {
    fetch('https://ipapi.co/json/')
      .then((res) => res.json())
      .then((data) => {
        setIsLoadCountry(true);
        setScreenNumber(
          data.country_name?.toLowerCase() === 'ukraine'
            ? !utm_campaign
              ? 14
              : 1
            : 13
        );
      })
      .catch((err) => console.error(err));
  }, []);

  const getScreen = (number, cb) => {
    switch (number) {
      case 1: {
        return (
          <WelcomeScreen
            isVisibleModal={isVisibleModal}
            setIsVisibleModal={setIsVisibleModal}
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => setScreenNumber(5)}
            telegramLink={telegramLink}
          />
        );
      }
      case 2: {
        return (
          <CompanyInfoScreen
            handleBackButtonClick={() => setScreenNumber(1, true)}
          />
        );
      }
      case 3: {
        return (
          <FaqScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1, true)}
          />
        );
      }
      case 4: {
        return <CookieManagementScreen setScreenNumber={setScreenNumber} />;
      }
      case 5: {
        return (
          <WelcomeAgeVerificationScreen
            setScreenNumber={setScreenNumber}
            handleBackButtonClick={() => setScreenNumber(1, true)}
            handleNextVerificationScreen={() => setScreenNumber(6)}
          />
        );
      }
      case 6: {
        return <FaceCaptureScreen setScreenNumber={setScreenNumber} />;
      }
      case 7: {
        return (
          <YoungAgeScreen backButtonClick={() => setScreenNumber(5, true)} />
        );
      }
      case 8: {
        return (
          <WelcomeFormScreen
            setScreenNumber={setScreenNumber}
            handleNextScreen={() => {
              sendEvent('registration');
              setScreenNumber(9);
            }}
            isHideSkipButton
            telegramLink={telegramLink}
          />
        );
      }
      case 9: {
        return (
          <FormScreen
            utm_campaign={utm_campaign}
            setScreenNumber={setScreenNumber}
            backButtonClick={() => setScreenNumber(8, true)}
            telegramLink={telegramLink}
            setFormData={(data) => setFormData(data)}
            formData={formData}
            isPromoter
          />
        );
      }
      case 10: {
        return (
          <OtpScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
            handleChangePhoneNumber={() => setScreenNumber(9)}
            successSendOtp={() => {
              sendEvent('passed_authorization');
              setScreenNumber(12);
            }}
            attemptsExhaustedChangeScreen={() => setScreenNumber(15)}
          />
        );
      }
      case 11: {
        return <AlreadyRegistered telegramLink={telegramLink} />;
      }
      case 12: {
        return <SuccessRegistered telegramLink={telegramLink} />;
      }
      case 13: {
        return (
          <GeoresctrictionScreen
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
          />
        );
      }
      case 14: {
        return (
          <ErrorPage
            setScreenNumber={setScreenNumber}
            telegramLink={telegramLink}
          />
        );
      }
      case 15: {
        return (
          <AttemptsExhausted
            setScreenNumber={setScreenNumber}
            checkPhoneNumber={() => setScreenNumber(9)}
            telegramLink={telegramLink}
          />
        );
      }
      case 16: {
        return (
          <NotRealFaceScreen
            setScreenNumber={setScreenNumber}
            handleRepeatButtonClick={() => setScreenNumber(6)}
          />
        );
      }
      case 500: {
        return <ErrorPage500 setScreenNumber={cb} />;
      }
      case 503: {
        return <ErrorPage503 setScreenNumber={cb} />;
      }
      case 404: {
        return <ErrorPage404 setScreenNumber={cb} />;
      }
      default: {
        return <ErrorPage404 setScreenNumber={cb} />;
      }
    }
  };
  return (
    isLoadCountry && (
      <div className={styles.pageContainer} id="ua-brand">
        <div className={styles.contentContainer}>
          <ScreensContext.Provider
            value={{
              endSessionType,
              setEndSessionType,
              isDisplayedAll,
              setIsDisplayedAll
            }}
          >
            {getScreen(screenNumber, setScreenNumber)}
          </ScreensContext.Provider>
        </div>
      </div>
    )
  );
};

export default Promoter;
